import type { IMockStore } from '@graphql-tools/mock';

import mockResolvers from '../spec/mockResolvers';

export const resolverOverrides = (mockStore: IMockStore) => ({
  ...mockResolvers(mockStore),
});
